import React from 'react';

import { trans } from '../../localization/index';

import EmptyIcon from '../../assets/common/static/icons/empty.png'

class TableEmpty extends React.Component {
  render() {
    const {txt} = this.props
    return (
      <div style={{
        padding:'240px 0 0 0',
        textAlign:'center',
        background:'#ececec'
      }}
      >
        <img
          src={EmptyIcon}
          alt="empty icon"
          style={{
            width:'118px'
          }} 
        />
        <div style={{
          margin:'27px 0 0',
          fontSize:'16px',
          lineHeight:'20px',
          color:'rgba(0, 0, 0, 0.87)',
          fontWeight:'500'
        }}
        >
          {trans(txt)}
        </div>
      </div>
    );
  }
}

export default TableEmpty;




// WEBPACK FOOTER //
// ./foody/src/components/Common/TableEmpty.jsx